var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFunctionsDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/twotone/maximize-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "maximize-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 139",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.25 2C15.25 1.58579 15.5858 1.25 16 1.25H20C20.4142 1.25 20.75 1.58579 20.75 2V6C20.75 6.41421 20.4142 6.75 20 6.75C19.5858 6.75 19.25 6.41421 19.25 6V2.75H16C15.5858 2.75 15.25 2.41421 15.25 2Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5303 1.46967C20.8232 1.76256 20.8232 2.23744 20.5303 2.53033L14.5303 8.53033C14.2374 8.82322 13.7626 8.82322 13.4697 8.53033C13.1768 8.23744 13.1768 7.76256 13.4697 7.46967L19.4697 1.46967C19.7626 1.17678 20.2374 1.17678 20.5303 1.46967Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 15.25C2.41421 15.25 2.75 15.5858 2.75 16V19.25H6C6.41421 19.25 6.75 19.5858 6.75 20C6.75 20.4142 6.41421 20.75 6 20.75H2C1.58579 20.75 1.25 20.4142 1.25 20V16C1.25 15.5858 1.58579 15.25 2 15.25Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53033 13.4697C8.82322 13.7626 8.82322 14.2374 8.53033 14.5303L2.53033 20.5303C2.23744 20.8232 1.76256 20.8232 1.46967 20.5303C1.17678 20.2374 1.17678 19.7626 1.46967 19.4697L7.46967 13.4697C7.76256 13.1768 8.23744 13.1768 8.53033 13.4697Z",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 11C0.25 5.06579 5.06579 0.25 11 0.25C11.7404 0.25 12.4696 0.325085 13.1671 0.464577C13.5733 0.545811 13.8367 0.94093 13.7555 1.3471C13.6742 1.75327 13.2791 2.01668 12.8729 1.93545C12.2704 1.81494 11.6396 1.75 11 1.75C5.89421 1.75 1.75 5.89421 1.75 11C1.75 11.6393 1.81487 12.2593 1.935 12.8507C2.01746 13.2566 1.75523 13.6525 1.34931 13.735C0.943383 13.8174 0.547475 13.5552 0.465022 13.1493C0.325159 12.4607 0.25 11.7407 0.25 11Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6528 8.26446C21.059 8.18323 21.4541 8.44664 21.5353 8.85281C21.6746 9.54916 21.7499 10.2684 21.7499 10.9999C21.7499 16.9341 16.9341 21.7499 10.9999 21.7499C10.2595 21.7499 9.53025 21.6748 8.83279 21.5353C8.42662 21.4541 8.16321 21.059 8.24445 20.6528C8.32568 20.2466 8.7208 19.9832 9.12697 20.0645C9.72951 20.185 10.3603 20.2499 10.9999 20.2499C16.1057 20.2499 20.2499 16.1057 20.2499 10.9999C20.2499 10.3714 20.1852 9.75064 20.0645 9.14699C19.9832 8.74082 20.2466 8.3457 20.6528 8.26446Z",
    fill: "#7C7C7C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunctionsDisabled);
export default __webpack_public_path__ + "static/media/functionsDisabled.bebbf0730ab8ffea604760d63275f200.svg";
export { ForwardRef as ReactComponent };